import { PropsWithChildren, useRef } from "react";
import { ScrollButton } from "../../../../shared/components/link/ScrollButton";
import { responsiveIconSizes } from "../../../../shared/styles/responsive.css";
import { heroSectionContainer, scrollButtonContainer } from "./styles.css";
import { smoothScroller } from "../../../../providers/smooth-scroller";
import { useHeroScroller } from "../../../../shared/utils/useHeroScroller";

export const HeroSection = ({ children }: PropsWithChildren) => {
  const sectionRef = useRef<HTMLDivElement>(null);

  const onScrollDown = () => {
    const nextSection = sectionRef.current?.nextElementSibling as HTMLElement;
    if (nextSection) {
      smoothScroller.scrollTo(nextSection);
    }
  };

  useHeroScroller({
    onScrollDown,
    target: sectionRef,
  });

  return (
    <div className={heroSectionContainer} ref={sectionRef}>
      {children}
      <div className={scrollButtonContainer}>
        <ScrollButton
          direction="down"
          onClick={onScrollDown}
          className={responsiveIconSizes}
        />
      </div>
    </div>
  );
};
